export type GdprRequest = {
  id: number;
  adminId: number;
  candidate: any;
  candidateId: number;
  kind: GdprRequestKind;
  message: string;
  completedAt: string;
  createdAt: string;
};

export enum GdprRequestKind {
  Removal = 'removal',
  Correction = 'change',
  Request = 'request',
}

export type OfferConfiguration = {
  id: number;
  emailConfirmation: boolean;
};

export interface AutoDeleteConfig {
  enabled: boolean | null;
  deleteHired: boolean | null;
  deleteQualifiedInJobs: boolean | null;
  deleteInTalentPools: boolean | null;
  deleteCandidatesWithoutConsentRequests: boolean | null;
  deleteRequestedCandidatesInDays: number | null;
  deleteWithoutEmailActivityInDays: number | null;
}

export interface GdprConfiguration {
  id: number;
  adminIds: number[];
  admins: any[];
  expirationDays: number;
  enabled: boolean;
  emailConfirmationFooterHtml: string;
  defaultEmailConfirmationFooterHtml: string;
  offers: OfferConfiguration[];
  companyId: number;
  translations: GdprTranslationItem[];
  consentPrivacyLink: string;
  autoConsent: {
    emailButtonText: string;
    emailP1: string;
    emailP2Html: string;
    emailTitle: string;
    enabled: boolean;
    emailBodyHtml: string | null;
    emailSubject: string | null;
    extendPeriodForDays: number | null;
    sendToCandidatesWithoutEmailActivityInDays: boolean | null;
    sendToQualified: boolean | null;
    sendToHired: boolean | null;
    sendToDisqualified: boolean | null;
    sendToCandidatesInTalentPools: boolean | null;
  };
  autoDelete: AutoDeleteConfig;
  hideCandidatesNames: boolean;
}

export type GdprSaveBody = {
  adminsIds?: number[];
  translations?: GdprSaveBodyTranslations[];
  expirationDays?: number;
  enabled?: boolean;
};

export type GdprSaveBodyTranslations = {
  emailConfirmationFooterHtml?: string;
  langCode?: string;
};

export type GdprTranslationItem = {
  defaultEmailConfirmationFooterHtml: string;
  emailConfirmationFooterHtml: string;
  language: GdprLanguageItem;
  primary: boolean;
};

type GdprLanguageItem = {
  code: string;
  name: string;
  nativeName: string;
  translationFieldsCount?: number;
};
export type GdprAutoConsentCounter = {
  candidatesCount: number;
};
